import React from "react";
import Batch from "../Batch";

const AttendanceBatches = () => {
    return <Batch status="training" title="Attendance" />;
};

export default AttendanceBatches;
